import { END_POINT } from "constants/apiConstant";
import { apiPost, apiGet } from "../utils/apiUtils";
import axiosClient from "axios-client";

export const digikeyCreateOrder = async (payload) => {
  const response = await apiPost(END_POINT.DIGIKEY_ORDER_CREATE, payload);
  console.log({ data: response });
  return response;
};

export const getAccountInfo = async () => {
  const response = await apiGet(END_POINT.DIGIKEY_ACCOUNT_INFO);
  console.log("getAccountInfo response", { data: response });
  return response;
};

export const getDigikeyTokenExpiryApi = async () => {
  const response = await apiGet(END_POINT.GET_DIGIKEY_TOKEN_EXPIRY_API);
  console.log("getDigikeyTokenExpiryApi=>", response);
  return response;
};

export const refreshDigikeyTokenApi = async () => {
  const response = await apiPost(END_POINT.REFRESH_DIGIKEY_TOKEN_API);
  console.log("getDigikeyTokenExpiryApi=>", response);
  return response;
};
